import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API_BASE_URL = apiMainUrl + 'Configuration';

// Get a specific configuration by name
const getConfigurationByName = async (name, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}`, { name } , {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch configuration:', error);
        throw error;
    }
};

// Update or create a configuration
const updateConfiguration = async (configParam, token) => {
    try {
        const response = await axios.put(API_BASE_URL, configParam, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to update configuration:', error);
        throw error;
    }
};

const getAllConfigurations = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch configurations:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

// Update only the values of configuration parameters
const updateConfigurationValues = async (configs, token) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/update-values`, configs, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to update configuration values:', error);
        throw error;
    }
};

const getTotalAvailableStorage = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/total-storage`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch total available storage:', error);
        throw error;
    }
};

export const ConfigurationDataService = {
    getConfigurationByName,
    updateConfiguration,
    getAllConfigurations,
    getTotalAvailableStorage,
    updateConfigurationValues
};
